import script from "./SlideComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideComponent.vue?vue&type=script&setup=true&lang=js"

import "./SlideComponent.vue?vue&type=style&index=0&id=bbdc27ac&scoped=true&lang=css"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbdc27ac"]])

export default __exports__